module.exports = __webpack_public_path__ + "img/shangxiajiubuxingjie.44459a25.png";